module.exports = [{"allowBackground":true,"pageColor":"0xffffff","placeholders":[{"left":0,"top":0,"width":0,"height":0}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/templates/flyleafes/front/landscape.json
// module id = 861
// module chunks = 0